// RoleAction.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import { Role } from './roleType';
import axios from 'axios'; 
import authServiceApiInstance from '../../../../config/apiConfig';

export const createRole = createAsyncThunk(
    'roles/create',
    async (roleData: Omit<Role, 'RoleId'>, { rejectWithValue }) => {
        try {
            const response = await authServiceApiInstance.post(`/roles`, roleData);
            return response.data; 
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to create role');
        }
    }
);

export const updateRole = createAsyncThunk(
    'roles/update',
    async ({ roleId, data }: { roleId: number; data: Partial<Role> }, { rejectWithValue }) => {
        try {
            const response = await authServiceApiInstance.put(`/roles/${roleId}`, data);
            return response.data; 
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to update role');
        }
    }
);

export const deleteRole = createAsyncThunk(
    'roles/delete',
    async (roleId: number, { rejectWithValue }) => {
        try {
            const response = await authServiceApiInstance.delete(`/roles/${roleId}`);
            return response.data; 
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to delete role');
        }
    }
);

export const fetchRoleById = createAsyncThunk(
    'roles/fetchById',
    async (roleId: number, { rejectWithValue }) => {
        try {
            const response = await authServiceApiInstance.get(`/roles/${roleId}`);
            return response.data; 
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch role');
        }
    }
);

export const fetchAllRoles = createAsyncThunk(
    'roles/fetchAll',
    async (_, { rejectWithValue }) => {
        try {
            const response = await authServiceApiInstance.get(`/roles`);
            return response.data; 
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Failed to fetch all roles');
        }
    }
);
